  import { Component, inject, OnInit, ChangeDetectorRef, Inject } from "@angular/core";
  import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
  import { TableConfiguration } from "../../../../shared/components/paginated-data-table/paginated-table-configuration.model";

  interface WarehouseTemperatureStability {
    warehouse_name: string;
    temperature_stability: number;
    summary: {
      total_readings: number;
      stable_temperature_readings: number;
      out_of_range_temperature_readings: number;
    };
  }

  interface TempStabilityModalData {
    stability: any;
    warehouseUniqueId?: string;
  }

  @Component({
    selector: "app-temp-stability-modal",
    templateUrl: "./temp-stability-modal.component.html",
    styleUrls: ["./temp-stability-modal.component.scss"],
  })
  export class TempStabilityModalComponent implements OnInit {

    private dialogRef = inject(MatDialogRef<TempStabilityModalComponent>);
    private cdr = inject(ChangeDetectorRef);

    constructor(@Inject(MAT_DIALOG_DATA) private data: TempStabilityModalData) {}

    title: string = "Temperature Stability";
    loading: boolean = true;
    refreshDataTable: boolean = false;

    tableData: WarehouseTemperatureStability[] = [];
    calculationMethod: any = null;
    interpretation: any = null;

    activeTab: "summary" | "table" = "summary";
    setTab(tab: "summary" | "table") {
      this.activeTab = tab;
    }

    tableConfiguration: TableConfiguration = {
      tableColumns: [
        { name: "warehouse_name", label: "Warehouse" },
        { name: "temperature_stability", label: "Temperature Stability (%)" },
      ],
      showNumbers: true,
      showSearch: true,
      useFullObject: true,
      showBorder: true,
      allowPagination: true,
      actionIcons: { edit: false, delete: false, more: false, print: false, customPrimary: false },
      doneLoading: false,
      empty_msg: "No data found",
      deleting: {},
      active: {},
    };

    ngOnInit(): void {
      const fullData = this.data?.stability;

      if (fullData) {
        this.calculationMethod = fullData.calculation_method;
        this.interpretation = fullData.interpretation;
        this.tableData = fullData.warehouses ?? [];
      }

      this.loading = false;
      this.tableConfiguration.doneLoading = true;
      this.cdr.detectChanges();
    }

    closeModal() {
      this.dialogRef.close();
    }
  }